import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy diary invite routes that now live under /invite/diary. */
const INVITE_ROUTE_MAP: Record<string, string> = {
    "diary/invite/diary": "/invite/diary/review",
    "diary/invite/user": "/invite/diary/patient",
    "diary/invite/complete": "/invite/diary/complete",
    "diary/qr": "/invite/diary/qr",
};

/** Legacy route: everything under /new moved to /templates (or /invite/diary for the invite steps). */
export const Route = createFileRoute("/_app/new/$")({
    beforeLoad: ({ params, location }) => {
        const splat = (params as { _splat?: string })._splat ?? "";
        // /new/template/* flattened to /templates/*; everything else maps 1:1.
        const flattened = splat.startsWith("template/") ? splat.slice("template/".length) : splat;
        const target = INVITE_ROUTE_MAP[splat] ?? `/templates/${flattened}`;
        throw redirect({ href: `${target}${location.searchStr ?? ""}`, replace: true });
    },
});
